'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxAuthWrapper = require('redux-auth-wrapper');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// User Authentication Higher Order Component (redirects to /login by default)
var UserIsAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
    authSelector: function authSelector(state) {
        return state.user.authorization;
    }, // get the user state
    wrapperDisplayName: 'UserIsAuthenticated' // a nice name for this auth check
});

var routes = _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.LoginPage }),
    _react2.default.createElement(_reactRouter.IndexRoute, { component: UserIsAuthenticated(_containers.PassengerListPage) }),
    _react2.default.createElement(
        _reactRouter.Route,
        { path: ':passengerId', component: UserIsAuthenticated(_containers.Passenger) },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.RequirementSetList }),
        _react2.default.createElement(_reactRouter.Route, { path: ':requirementSet', component: _containers.RequirementSet })
    )
);

exports.default = routes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/routes.js
// module id = 1406
// module chunks = 0